import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { TextAreaBox, Switch, TextBox } from 'fw/forms';
import { Label, ActionButton } from 'fw/components';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';
import { CommentsGrid } from 'areas/shared/components';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel'
import { SiteReviewOpSignaturesCombo, SiteReviewOpDollarVolumeCombo, SiteReviewOpHoursPerWeekCombo } from 'areas/shared/controls';
import BusinessStaff from 'areas/admin/certification/certificationInfo/businessStructure/businessStaff';
import * as Notifications from 'fw/globals/Notifications';
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import * as ReportManager from 'modules/reports/ReportManager';

class OperationAndControl extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            businessStaff: [],
            reviewComment: ''
        }
    }

    componentWillMount() {
        this.setState({
            showBusinessStaffPopUp: false,
            currentBusinessStaff: this.newBusinessStaff()
        })
    }

    onBusinessStaffEdit = (index) => {
        this.setState({
            showBusinessStaffPopUp: true,
            currentBusinessStaff: this.state.form.businessStaff[index]
        })
    }

    onBusinessStaffChange = (businessStaff) => {
        let form = this.state.form

        var index = form.businessStaff.findIndex(function (element) {
            return element.businessFunctionId === businessStaff.businessFunctionId
        })

        if (index >= 0) form.businessStaff[index] = businessStaff
        else form.businessStaff = form.businessStaff.concat(businessStaff)

        if (businessStaff.businessStructureStaffId > 0) Notifications.success('The Staff Member has been updated.')
        else Notifications.success('The Staff Member has been added.')

        this.updatePostData(form, true)
    }

    onBusinessStaffGridChange = (businessStaff) => {
        let form = this.state.form;

        var index = form.businessStaff.findIndex(function (element) {
            return element.businessFunctionId === businessStaff.businessFunctionId
        })

        form.businessStaff[index] = businessStaff;

        this.updatePostData(form, true)
    }

    newBusinessStaff = () => {
        let item = {
            businessStructureStaffId: this.businessStructureStaffId,
            firstName: '',
            lastName: '',
            title: '',
            businessFunctionId: null,
            functionName: '',
            otherFunction: '',
            email: '',
            phones: []
        }

        this.businessStructureStaffId--
        return item
    }

    privileges() {
        return {
            add: App.hasPrivilege('AdminSiteReviewAccess'),
            edit: App.hasPrivilege('AdminSiteReviewAccess')
        }
    }

    urls() {
        return {
            get: API.Admin.url('/siteReview/getOperationAndControl'),
            save: API.Admin.url('/siteReview/saveOperationAndControl')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
        }
    }

    saveRequest() {
        return {
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            certificationKey: this.props.selectedId,

            dayToDayOperation: this.state.form.dayToDayOperation,
            ownerReponsibilities: this.state.form.ownerReponsibilities,
            managementDecisionsAtOwnerAbsence: this.state.form.managementDecisionsAtOwnerAbsence,
            decisionsFinalWord: this.state.form.decisionsFinalWord,
            siteReviewOpSignaturesId: this.state.form.siteReviewOpSignaturesId,
            signaturesExplanation: this.state.form.signaturesExplanation,
            customer1: this.state.form.customer1,
            customer1DollarVolumeId: this.state.form.customer1DollarVolumeId,
            customer2: this.state.form.customer2,
            customer2DollarVolumeId: this.state.form.customer2DollarVolumeId,
            customer3: this.state.form.customer3,
            customer3DollarVolumeId: this.state.form.customer3DollarVolumeId,
            siteReviewOpHoursPerWeekId: this.state.form.siteReviewOpHoursPerWeekId,
            businessHours: this.state.form.businessHours,
            otherWork: this.state.form.otherWork,
            otherWorkBusinessType: this.state.form.otherWorkBusinessType,
            otherOwnershipInterest: this.state.form.otherOwnershipInterest,
            otherOwnershipInterestDetail: this.state.form.otherOwnershipInterestDetail,
            businessStaff: this.state.form.businessStaff,

            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewComment: this.state.reviewComment
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    updatePostData = (form, dirty) => {
        this.setState({ form })

        if (dirty === true) this.dirt()
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    ready = () => {
        // If slected form is paper -> Redirect to FinalRecomm
        if (this.state.form.isPaperForm)
            window.location.href = `/admin/siteReview/${this.props.selectedId}/finalRecomm/${this.props.queueTypeCode}`;
    }
    
    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleAppReviewToolbar = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    blankSignaturesExplanation = () => {
        let form = this.state.form;

        if (this.state.form.siteReviewOpSignaturesId !== 6)
            form.signaturesExplanation = null;

        this.updatePostData(form, true);
    }

    blankOtherCompanyWork = () => {
        let form = this.state.form;

        if (!form.otherWork)
            form.otherWorkBusinessType = null;

        this.updatePostData(form, true);
    }

    blankOtherCompanyOwnershipInterest = () => {
        let form = this.state.form;

        if (!form.otherOwnershipInterest)
            form.otherOwnershipInterestDetail = null;

        this.updatePostData(form, true);
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewOperationAndControlReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'SOC'}
                queueTypeCode={'STR'}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        {this.state.form.showReview ?
                            <AppReviewToolbar
                                queueTypeCode={'STR'}
                                reviewTypeCode={'SOC'}
                                comments={this.state.form.comments}
                                onFlagSave={this.handleAppReviewToolbar}
                                certificationKey={this.props.selectedId} />
                            : null}
                    </Col>
                    <Col md={4}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3>
                            {this.state.form.siteReviewTitle}
                            {this.renderAdminStepToolbar()}
                            <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                        </h3>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label required htmlFor="dayToDayOperation">Describe day-to-day Operation of your Company. Please include who does what (i.e., describe the Company activities on a typical day)</Label>
                                    <TextAreaBox required name="dayToDayOperation" maxLength={500} rows={3} />
                                </FormGroup>
                                <FormGroup>
                                    <Label required htmlFor="ownerReponsibilities">As the Owner, what are your Duties and Responsibilities?</Label>
                                    <TextAreaBox required name="ownerReponsibilities" maxLength={500} rows={3} />
                                </FormGroup>
                                <FormGroup>
                                    <Label required htmlFor="managementDecisionsAtOwnerAbsence">How are Management decisions made when you're not available, and who makes them?</Label>
                                    <TextAreaBox required name="managementDecisionsAtOwnerAbsence" maxLength={500} rows={3} />
                                </FormGroup>
                                <FormGroup>
                                    <Label required htmlFor="decisionsFinalWord">Who has the final word on all Company decisions (Please explain why)?</Label>
                                    <TextAreaBox required name="decisionsFinalWord" maxLength={500} rows={3} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <h3>Staff &amp; Responsibilities <small>Please identify primary decision makers within your Company</small>
                                    <small className="required-indicator"> *</small></h3>
                                <hr />
                            </Col>
                        </Row>
                        {this.state.form.hasBusinessStructure ?
                            <React.Fragment>
                                <Row>
                                    <Col md={12}>
                                        <BusinessStaff
                                            businessStaff={this.state.form.businessStaff}
                                            onEdit={this.onBusinessStaffEdit}
                                            onChange={this.onBusinessStaffGridChange}
                                            reviewMode />
                                    </Col>
                                </Row>
                            </React.Fragment>
                            :
                            <Row>
                                <Col md={12}>
                                    <h4 style={{ color: 'red' }}><u>Attention!</u> Certification's step "Business Structure" must be completed in order to review this section</h4>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col md={12}><br /></Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Label required htmlFor="siteReviewOpSignaturesId">How many signatures are required for Legal and Financial decisions within the Company?</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <SiteReviewOpSignaturesCombo required onChange={this.blankSignaturesExplanation} name="siteReviewOpSignaturesId" />
                                </FormGroup>
                            </Col>
                        </Row>
                        {this.state.form !== null && this.state.form.siteReviewOpSignaturesId === 6 ? ( // Change this to ask for 'Other'
                            <Row>
                                <Col md={5}>
                                    <TextAreaBox required name="signaturesExplanation" maxLength={500} rows={4} placeholder='If selected required signatures is ‘Other’, please explain.' />
                                    <br />
                                </Col>
                            </Row>
                        ) : null}
                        <Row>
                            <Col md={12}>
                                <Label required>Who are your 3 largest Customers by dollar volume?</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <TextBox required name="customer1" placeholder="Customer 1" maxLength={50} />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <SiteReviewOpDollarVolumeCombo required name="customer1DollarVolumeId" />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <TextBox required name="customer2" placeholder="Customer 2" maxLength={50} />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <SiteReviewOpDollarVolumeCombo required name="customer2DollarVolumeId" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <TextBox required name="customer3" placeholder="Customer 3" maxLength={50} />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <SiteReviewOpDollarVolumeCombo required name="customer3DollarVolumeId" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <Label htmlFor='siteReviewOpHoursPerWeekId' required>
                                    How many hours per week do you devote to the Business?
                                </Label>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <SiteReviewOpHoursPerWeekCombo required name='siteReviewOpHoursPerWeekId' />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label required htmlFor="businessHours">Business Hours</Label>
                                    <TextBox required name="businessHours" placeholder="Business Hours..." maxLength={50} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={7}>
                                <FormGroup>
                                    <Label htmlFor="otherWork">Do you currently work for any other Company in addition to your own?</Label>
                                    <Switch onChange={this.blankOtherCompanyWork} name="otherWork" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                </FormGroup>
                                {this.state.form.otherWork ?
                                    (
                                        <FormGroup>
                                            <Label htmlFor="otherWorkBusinessType" required>Please explain the Company and type of Business</Label>
                                            <TextAreaBox
                                                required
                                                name="otherWorkBusinessType"
                                                placeholder="Please explain the Company and type of Business"
                                                maxLength={500}
                                                rows={3} />
                                        </FormGroup>
                                    ) : null}

                                <FormGroup>
                                    <Label htmlFor="otherOwnershipInterest">Do you have Ownership Interest in any other Company?</Label>
                                    <Switch onChange={this.blankOtherCompanyOwnershipInterest} name="otherOwnershipInterest" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                </FormGroup>
                                {this.state.form.otherOwnershipInterest ?
                                    (
                                        <FormGroup>
                                            <Label htmlFor="otherOwnershipInterestDetail" required>Please name the Companies of Interest, Percentages Owned, and hours spent working there</Label>
                                            <TextAreaBox
                                                required
                                                name="otherOwnershipInterestDetail"
                                                placeholder="Please name the Companies of Interest, Percentages Owned, and hours spent working there"
                                                maxLength={500}
                                                rows={3} />
                                        </FormGroup>
                                    ) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>

                    </Col>
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={this.state.form.comments}
                        documents={this.state.form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"SOC"}
                        queueTypeCode={"STR"}
                        enableExport={true}
                        entityId={this.state.form.entityId}
                        readonly={!this.state.privileges.edit || !this.state.enabled}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange} />
                </Row>
                {this.state.form.showComplete ?
                    <Row>
                        <ReviewPanel stepName="Operation & Control"
                            onChange={this.handleReviewStatus} reviewStatus={this.state.form.reviewStatus} />
                    </Row>
                : null}
            </React.Fragment>
        )
    }
}

export default OperationAndControl;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/operationAndControl/OperationAndControl.js